import axios from "axios";

const publicApi = axios.create({ baseURL: process.env.REACT_APP_BASE_URL });

const handle = async (label, promise) => {
 try {
 const res = await promise;
 return { status: res.status, data: res.data };
 } catch (err) {
 return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed" };
 }
};

export const fetchGroups = (params = {}) => {
 const cleaned = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== "" && v != null));
 return handle("Fetch groups", publicApi.get("/public/similar-words/groups", { params: cleaned }));
};
export const fetchGroupById = (id) => handle(`Fetch group ${id}`, publicApi.get(`/public/similar-words/groups/${id}`));
export const fetchWordsByGroup = (groupId) => handle(`Fetch words for group ${groupId}`, publicApi.get(`/public/similar-words/groups/${groupId}/words`));
